export default "__VITE_ASSET__U$4powYx__"